import React from "react";
import moment from "moment";
import Barcode from "react-barcode";
import "./AcceptProductSticker.scss";

const formatPrice = (price) => {
  if (price == null) return "";
  const num = Number(price);
  if (Number.isNaN(num)) return "";
  return `${num.toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ₽`;
};

const AcceptProductSticker = ({ product, amount, acceptanceDate }) => {
  const date = acceptanceDate ? moment(acceptanceDate) : moment();
  return (
    <div className="accept_product_sticker">
      <div className="accept_product_sticker__content">
        <div className="accept_product_sticker__article">
          {product.article_number || ""}
        </div>
        <div className="accept_product_sticker__date">
          <div>{date.format("DD.MM.YYYY")}</div>
        </div>
        {product.article_number && (
          <div className="accept_product_sticker__barcode">
            <Barcode
              value={product.article_number}
              width={1.1}
              height={40}
              margin={0}
              displayValue={false}
            />
          </div>
        )}
        <div className="accept_product_sticker__amount">
          {amount}
          <span className="accept_product_sticker__amount-unit">шт.</span>
        </div>
      </div>
      <div className="accept_product_sticker__supplier">
        {product.supplier_company || ""}
      </div>
    </div>
  );
};

export default AcceptProductSticker;
